/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './BensServicosConteudos.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function BensServicosConteudos() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="bens-servicos-conteudos">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="bens-servicos-conteudos-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`bens-servicos-conteudos-slide ${className}`}>
                    <a
                      href="blog/planejamento-de-moveis-planejados.html"
                      target="_blank"
                      className="bens-servicos-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-67/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-67/capa.png" />
                        <img
                          src="static/amp/blog/post-67/capa.png"
                          alt="Casal caminha de mãos dadas em loja de móveis, simbolizando o planejamento e a escolha consciente de móveis planejados para o lar."
                        />
                      </picture>
                      <div className="bens-servicos-conteudos-card-textos">
                        <h3 className="bens-servicos-conteudos-slide-titulo">
                          Como fazer o planejamento financeiro para seus móveis planejados?
                        </h3>
                        <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`bens-servicos-conteudos-slide ${className}`}>
                    <a
                      href="blog/economize-na-conta-de-luz-com-energia-solar.html"
                      target="_blank"
                      className="bens-servicos-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-20/capa.webp" />
                        <source type="image/jpeg" srcSet="static/amp/blog/post-20/capa.jpeg" />
                        <img
                          src="static/amp/blog/post-20/capa.jpeg"
                          alt="lâmpada com filetes amarelos em cima de uma placa de energia solar"
                        />
                      </picture>
                      <div className="bens-servicos-conteudos-card-textos">
                        <h3 className="bens-servicos-conteudos-slide-titulo">
                          Economize na sua conta de luz com energia solar fotovoltaica
                        </h3>
                        <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`bens-servicos-conteudos-slide ${className}`}>
                    <a
                      href="blog/passos-para-organizar-sua-vida-financeira.html"
                      target="_blank"
                      className="bens-servicos-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-25/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-25/capa.jpg" />
                        <img
                          src="static/amp/blog/post-25/capa.jpg"
                          alt="Cofre no formato de porco  com um balão de pensamentos sobre educação financeira em uma superfície branca ao lado de quatro pilhas de moedas em sequencia em forma crescente."
                        />
                      </picture>
                      <div className="bens-servicos-conteudos-card-textos">
                        <h3 className="bens-servicos-conteudos-slide-titulo">
                          Passo a passo para organizar sua vida financeira
                        </h3>
                        <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="bens-servicos-conteudos-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/planejamento-de-moveis-planejados.html"
                target="_blank"
                className="bens-servicos-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-67/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-67/capa.png" />
                  <img
                    src="static/amp/blog/post-67/capa.png"
                    alt="Casal caminha de mãos dadas em loja de móveis, simbolizando o planejamento e a escolha consciente de móveis planejados para o lar."
                  />
                </picture>
                <div className="bens-servicos-conteudos-card-textos">
                  <h3 className="bens-servicos-conteudos-slide-titulo">
                    Como fazer o planejamento financeiro para seus móveis planejados?
                  </h3>
                  <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/economize-na-conta-de-luz-com-energia-solar.html"
                target="_blank"
                className="bens-servicos-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-20/capa.webp" />
                  <source type="image/jpeg" srcSet="static/amp/blog/post-20/capa.jpeg" />
                  <img
                    src="static/amp/blog/post-20/capa.jpeg"
                    alt="lâmpada com filetes amarelos em cima de uma placa de energia solar"
                  />
                </picture>
                <div className="bens-servicos-conteudos-card-textos">
                  <h3 className="bens-servicos-conteudos-slide-titulo">
                    Economize na sua conta de luz com energia solar fotovoltaica
                  </h3>
                  <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/passos-para-organizar-sua-vida-financeira.html"
                target="_blank"
                className="bens-servicos-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-25/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-25/capa.jpg" />
                  <img
                    src="static/amp/blog/post-25/capa.jpg"
                    alt="Cofre no formato de porco  com um balão de pensamentos sobre educação financeira em uma superfície branca ao lado de quatro pilhas de moedas em sequencia em forma crescente."
                  />
                </picture>
                <div className="bens-servicos-conteudos-card-textos">
                  <h3 className="bens-servicos-conteudos-slide-titulo">
                    Passo a passo para organizar sua vida financeira
                  </h3>
                  <p className="bens-servicos-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default BensServicosConteudos;
